import BaseEntity from '../BaseEntity';
import { IPoint2d } from '@/editor/math/IPoint2d';
import ContourModel from '../2d/contourModel';
import { ENTITY_RENDER_ORDER } from '@/editor/constant/entity';

function isStrictEqualPolygon(polygon1: IPoint2d[][], polygon2: IPoint2d[][]) {
  const p1 = polygon1.flat();
  const p2 = polygon2.flat();
  if (p1.length !== p2.length) return false;
  return p1.every((point, index) => point.x === p2[index].x && point.y === p2[index].y);
}

export default class WallSelectedEntity extends BaseEntity {
  protected override _model2d: ContourModel;
  private _created: boolean = false;
  private _path: IPoint2d[] = [];
  private _color: number;
  private _fill: boolean;

  constructor(options: { color: number; fill: boolean }) {
    super();

    this._color = options.color;
    this._fill = options.fill;

    this._model2d = new ContourModel();
    this._model2d.setDisplayOrder(ENTITY_RENDER_ORDER.renderOrderTemp);
  }

  get created() {
    return this._created;
  }

  override update(path: IPoint2d[]) {
    // let noDestroyUpdate = false;
    let needDestroyUpdate = !this._created || false;

    if (path && !isStrictEqualPolygon([path], [this._path])) {
      this._path = path;
      needDestroyUpdate = true;
    }

    if (needDestroyUpdate) {
      this.clear();
      this._model2d.createModel({ contour: this._path, holes: [], color: this._color, fill: this._fill });
      this._created = true;
    }
  }

  clear() {
    this._model2d.clear();
    this._created = false;
  }
}
